import React from 'react'
import { withTranslationCustom } from 'lib/i18next'

import Button from 'components/UI/Button'

import './maps-place-select-header.pcss'

const MapsPlaceSelectHeader = ({ t, onCloseRequest }) => {
    return (
        <div className="maps-place-select-header">
            <div>
                <Button
                    trackName="closeMap"
                    className="button button--tertiary maps-place-select-header__close-button"
                    onClick={onCloseRequest}
                >
                    <span />
                </Button>
            </div>
            {/*
            <div className="maps-place-select-header__buttons-container">
                <div className="maps-place-select-header__buttons">
                    <Button
                        trackName="closePlaceSelect"
                        className="maps-place-select__close-button button button--tertiary"
                        onClick={onCloseRequest}
                    >
                        {t('common:close')}
                    </Button>
                </div>
            </div>
             */}
        </div>
    )
}

export default withTranslationCustom('common')(MapsPlaceSelectHeader)
